import React, { useState } from 'react';
import { firestore } from '../../firebase/config';
import { doc, updateDoc } from 'firebase/firestore';
import './GerenciarUsuarios.css';

function EditarUsuarioModal({ usuario, onClose, onSuccess }) {
  const [nome, setNome] = useState(usuario.nome || '');
  const [perfil, setPerfil] = useState(usuario.perfil || 'agente');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const userRef = doc(firestore, 'usuarios', usuario.id);
      await updateDoc(userRef, {
        nome: nome,
        perfil: perfil
      });
      onSuccess();
    } catch (err) {
      console.error("Erro ao atualizar usuário:", err);
      setError("Erro ao atualizar o usuário. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content usuario-modal">
        <h3>Editar Usuário</h3>
        
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome Completo</label>
            <input 
              type="text" 
              value={nome} 
              onChange={(e) => setNome(e.target.value)} 
              required 
            />
          </div>

          <div className="form-group">
            <label>Email (Não Editável)</label>
            <input 
              type="email" 
              value={usuario.email} 
              disabled 
            />
          </div>

          <div className="form-group">
            <label>Perfil de Acesso</label>
            <select value={perfil} onChange={(e) => setPerfil(e.target.value)} required>
              <option value="agente">Agente</option>
              <option value="supervisor">Supervisor</option>
              <option value="laboratorio">Laboratório</option>
              <option value="gestor">Gestor</option>
            </select>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditarUsuarioModal;
